import { createFileRoute } from "@tanstack/react-router";

import { DefiPositionDetailPage } from "../../features/defi/pages/defi-position-detail-page";

export const Route = createFileRoute("/_layout/defi/positions/$positionAddress")({
  component: DefiPositionDetailPage,
  staticData: {
    layout: {
      showNavigationTabs: false,
    },
  },
});
